import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag",
  "use": "icon-flag-usage",
  "viewBox": "0 0 12 16",
  "content": "<symbol viewBox=\"0 0 12 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-flag\">\n<path d=\"M0.23999 0.639893V15.0399H1.45262V10.2399L11.76 5.43989L1.45262 0.639893H0.23999ZM1.45262 1.63364L9.63789 5.43989L1.45262 9.24614V1.63364Z\" fill=\"#465669\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol